import { DbFocusOptions, DbFolder } from '~src/types/db';
import { StateDataNode } from '../LeftSideView';
import { DB_STATE } from '~src/types/enums';
import { useStyles } from '~src/hooks/useStyles';
import IconButton from '~components/_common/IconButton/IconButton';
import { styleFn } from '../style';
import { NavIcon } from '~components/_common/NavIcon/NavIcon';

import FileTenderHammerSrc from '~src/assets/nav-icons/file-tender-hammer.svg';
import TenderFolderSrc from '~src/assets/nav-icons/folder-tender.svg';
import FileTender from '~src/assets/nav-icons/file-tender.svg';
import FolderTenderHammer from '~src/assets/nav-icons/folder-tender-hammer.svg';
import { find } from 'lodash';

export const getTenderIcon = (option) => {
  const { tender_registration_id, is_tender_root_folder } = option;
  if (is_tender_root_folder && tender_registration_id)
    return FileTenderHammerSrc;
  if (is_tender_root_folder && !tender_registration_id)
    return FolderTenderHammer;
  if (tender_registration_id) return FileTender;
  return TenderFolderSrc;
};

export const getTenderIconArichive = (option) => {
  const isTenderDocumentsRelatedPath = /\/tenders\/\d+\/documents\/tender-folders\/\d+\/folders\/\d+/.test(
    window.location.pathname
  );
  if (isTenderDocumentsRelatedPath) return TenderFolderSrc;
  if (!option) return FolderTenderHammer;
  const { is_tender_root_folder, is_sub_folder, is_tender_folder } = option;
  if (is_tender_root_folder && is_tender_folder) return FolderTenderHammer;
  if (is_tender_root_folder) return FileTenderHammerSrc;
  if (is_sub_folder || (!is_tender_root_folder && is_tender_folder))
    return TenderFolderSrc;
  return FolderTenderHammer;
};

const FolderIcon = (props) => {
  const styles = useStyles(styleFn);
  const { is_empty, state, option } = props;
  return option?.is_tender_folder ? (
    !option?.is_tender_root_folder ? (
      <IconButton
        iconStyle="fas"
        customStyle={styles.icons}
        icon={'folder'}
        iconSecond={state === DB_STATE.REMOVED ? ['fad', 'trash'] : null}
        colorSecondIcon={'red'}
        customStyleSecondIcon={{ right: '-3px', top: '12px' }}
        color={'tenderBlue'}
        backgroundOff
        badge={state !== DB_STATE.REMOVED && is_empty && '0'}
        badgeStyle={styles.badge}
        {...props}
      />
    ) : (
      <NavIcon icon={getTenderIconArichive(option)} />
    )
  ) : (
    <IconButton
      iconStyle="fas"
      customStyle={styles.icons}
      icon={'folder'}
      iconSecond={state === DB_STATE.REMOVED ? ['fad', 'trash'] : null}
      colorSecondIcon={'red'}
      customStyleSecondIcon={{ right: '-3px', top: '12px' }}
      color={'yellow'}
      backgroundOff
      badge={state !== DB_STATE.REMOVED && is_empty && '0'}
      badgeStyle={styles.badge}
      {...props}
    />
  );
};

const dbFolderToTreeObj = (dbFolder: DbFolder): StateDataNode => {
  const {
    id,
    name,
    parent_id,
    is_empty,
    is_favorite,
    state,
    option,
  } = dbFolder;
  return {
    title: name || 'Unknown',
    key: String(id),
    keyPath: String(id),
    type: 'archive',
    icon: <FolderIcon option={option} is_empty={is_empty} state={state} />,
    children: [],
    parentId: String(parent_id),
    favourite: is_favorite,
  };
};

const getSelectedClassNameNum = (
  dbFolder?: DbFolder,
  currentFolder?: DbFolder
) => {
  if (dbFolder?.id === currentFolder?.id) {
    return dbFolder?.focus;
  }
};

// TODO: look into efficiency improvements
/**
 * transforms db folder list in directory tree
 */

const getBackgroundComponent = (
  theme: any,
  focusOptions?: DbFocusOptions[],
  dbFolder?: DbFolder,
  currentFolder?: DbFolder
) => {
  const data =
    dbFolder && dbFolder.focus
      ? find(focusOptions, {
          value: dbFolder.focus,
        })
      : '';

  if (dbFolder?.id === currentFolder?.id && data) {
    return {
      color:
        window.sessionStorage.getItem('appState') === 'timeMachine'
          ? theme.colors.text.secondary
          : theme.colors.text.primary,
      background: `${data ? '#' + data.color_hex_code_opacity : ''}`,
    };
  }
  return {
    color:
      window.sessionStorage.getItem('appState') === 'timeMachine' && data
        ? theme.colors.text.secondary
        : theme.colors.text.primary,

    background: `${data ? '#' + data.color_hex_code : ''}`,
  };
};

export const arrToTree = (
  arr: DbFolder[],
  parentId: DbFolder['parent_id'],
  theme: any,
  focusOptions?: DbFocusOptions[],
  currentFolder?: DbFolder
): StateDataNode[] => {
  return arr
    .filter((dbFolder) => dbFolder.parent_id === parentId)
    .map((dbFolder) => {
      const children = arrToTree(
        arr,
        dbFolder.id,
        theme,
        focusOptions,
        currentFolder
      );
      return {
        ...dbFolderToTreeObj(dbFolder),
        children,
        createdAt: dbFolder.created_at,
        description: dbFolder.description,
        name: dbFolder.name,
        isLeaf: children.length === 0,
        className: `ant-table-row-selected${getSelectedClassNameNum(
          dbFolder,
          currentFolder
        )}`,
        style: getBackgroundComponent(
          theme,
          focusOptions,
          dbFolder,
          currentFolder
        ),
      };
    });
};

export const changeKeysWithoutRepeat = ({
  changedKey,
  newKeys,
  prevKeys,
}: {
  prevKeys: string[];
  newKeys?: string[];
  changedKey: string;
}) =>
  prevKeys.includes(changedKey)
    ? prevKeys
    : [
        ...(newKeys
          ? prevKeys.filter(
              (prevKey) => !newKeys.some((newKey) => newKey === prevKey)
            )
          : prevKeys),
        ...(newKeys ? newKeys : [changedKey]),
      ];
